import {
  loadSearchAnalyticsActions,
  loadQueryActions,
  loadConfigurationActions,
  loadSearchActions,
} from '@coveo/headless';
import { useEffect, useState } from 'react';
import { useCoveoSearchEngine } from './CoveoSearchEngine';
import { GlobalSearchLocalStorageName, UrlParamNameSearch, UrlParamTypeSearch } from './Helpers/AppHelper';
import { ReactHelper } from 'Utilities/ReactHelper';
import SearchPageContent from './SearchPageContent';

interface ISearchPageProps {
  searchOnLoad: boolean;
  showAISummary?: boolean;
}
export function SearchPage({ searchOnLoad, showAISummary }: ISearchPageProps) {
  const { headlessEngine } = useCoveoSearchEngine();
  const { logSearchFromLink } = loadSearchAnalyticsActions(headlessEngine!);
  const { updateQuery } = loadQueryActions(headlessEngine!);
  const { setOriginLevel3 } = loadConfigurationActions(headlessEngine!);
  const { executeSearch } = loadSearchActions(headlessEngine!);
  const [queryType, setQueryType] = useState<string>(() =>
    new URLSearchParams(window.location.search).get(UrlParamTypeSearch) ?? '',
  );

  useEffect(() => {
    const TrackRedirect = () => {
      if (document.referrer) {
        let referrer = new URL(document.referrer);
        if (referrer.origin && referrer.origin !== '') {
          let originLevel3 = referrer.pathname ? referrer.origin + referrer.pathname : referrer.origin;
          headlessEngine!.dispatch(setOriginLevel3({ originLevel3: originLevel3 }));
        }
      }
    };
    const SearchByStandaloneBox = (): boolean => {
      const data = localStorage.getItem(GlobalSearchLocalStorageName);
      if (data) {
        localStorage.removeItem(GlobalSearchLocalStorageName);
        const { value } = JSON.parse(data);
        // Adding search terms to url makes page bookmarkable and back button navigation to re-search
        ReactHelper.addUrlParamWithoutRefresh(UrlParamNameSearch, value);
        headlessEngine!.dispatch(updateQuery({ q: value }));
        TrackRedirect();
        if (!headlessEngine!.state.search.isLoading)
          if (searchOnLoad) {
            headlessEngine!.dispatch(executeSearch(logSearchFromLink()));
          } else {
            headlessEngine!.executeFirstSearch();
          }
        return true;
      }
      return false;
    };

    const SearchByUrlParam = (): boolean => {
      setQueryType(new URLSearchParams(window.location.search).get(UrlParamTypeSearch) ?? '');

      const searchParam = new URLSearchParams(window.location.search).get(UrlParamNameSearch);

      if (searchParam) {
        headlessEngine!.dispatch(updateQuery({ q: searchParam }));
        TrackRedirect();
        if (!headlessEngine!.state.search.isLoading) headlessEngine!.dispatch(executeSearch(logSearchFromLink()));
        return true;
      }
      return false;
    };
    if (!SearchByStandaloneBox()) {
      if (!SearchByUrlParam()) {
        if (!headlessEngine!.state.search.isLoading && searchOnLoad) headlessEngine!.executeFirstSearch();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <SearchPageContent queryType={queryType} showAISummary={showAISummary} />;
}
